import { isAllowedImageType } from "@shared/products/photo-constraints";
import { reencodeInBrowser } from "./storable-format";

function isHeicFile(file: File): boolean {
  if (file.type === "image/heic" || file.type === "image/heif") return true;
  return !isAllowedImageType(file.type) && /\.hei[cf]$/i.test(file.name);
}

async function convertWithLibheif(file: File, nativeError: unknown): Promise<File> {
  if (import.meta.env.SSR) throw nativeError;
  const { heicTo } = await import("heic-to");
  let converted: Blob;
  try {
    converted = await heicTo({ blob: file, type: "image/jpeg", quality: 0.9 });
  } catch {
    throw nativeError;
  }
  const newName = file.name.replace(/\.(heic|heif)$/i, ".jpg");
  return new File([converted], newName, { type: "image/jpeg" });
}

export async function convertHeicIfNeeded(file: File): Promise<File> {
  if (!isHeicFile(file)) {
    return file;
  }

  try {
    return await reencodeInBrowser(file);
  } catch (nativeError) {
    return await convertWithLibheif(file, nativeError);
  }
}
